import { cn } from '../../lib/utils';

export type InsetStatCalloutProps = {
  title: string;
  subtitle: string;
  className?: string;
};

export function InsetStatCallout({
  title,
  subtitle,
  className,
}: InsetStatCalloutProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-border bg-card/95 px-4 py-3 text-card-foreground shadow-sm backdrop-blur-sm',
        className,
      )}
    >
      <p className='font-heading text-base font-bold tracking-tight text-foreground'>
        {title}
      </p>
      <p className='mt-0.5 text-sm font-normal text-muted-foreground'>
        {subtitle}
      </p>
    </div>
  );
}
